import {
  ApiBlueprint,
  PageBlueprint,
  createApiFactory,
  createFrontendPlugin,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/frontend-plugin-api';
import ReceiptIcon from '@material-ui/icons/Receipt';
import { oktaAuthApiRef } from '@backstage/frontend-plugin-api';
import {
  rootRouteRef,
  accountDetailsRouteRef,
  accountsQueryRouteRef,
  entitlementDetailsRouteRef,
} from './routes';
import { billingAccountApiRef } from './types';
import { UbsAccountsApi } from './apis';

// ── API (→ global API registry) ─────────────────────────
const billingAccountApi = ApiBlueprint.make({
  name: 'billing-account-api',
  params: defineParams =>
    defineParams(
      createApiFactory({
        api: billingAccountApiRef,
        deps: {
          discoveryApi: discoveryApiRef,
          fetchApi: fetchApiRef,
          oktaAuthApi: oktaAuthApiRef,
        },
        factory: ({ discoveryApi, fetchApi, oktaAuthApi }) =>
          new UbsAccountsApi({ discoveryApi, fetchApi, oktaAuthApi }),
      }),
    ),
});

// ── Routes (→ app/routes) ───────────────────────────────
const searchPage = PageBlueprint.make({
  params: {
    title: 'Billing',
    icon: <ReceiptIcon fontSize="inherit" />,
    path: '/billing',
    routeRef: rootRouteRef,
    noHeader: true,
    loader: () => import('./components').then(m => <m.UbsSearchPage />),
  },
});

const accountDetailPage = PageBlueprint.make({
  name: 'account-detail',
  params: {
    path: '/billing/account/:billingID',
    routeRef: accountDetailsRouteRef,
    noHeader: true,
    loader: () => import('./components').then(m => <m.UbsAccountDetailsPage />),
  },
});

const accountsListPage = PageBlueprint.make({
  name: 'accounts-list',
  params: {
    path: '/billing/accounts',
    routeRef: accountsQueryRouteRef,
    noHeader: true,
    loader: () => import('./components').then(m => <m.UbsAccountsPage />),
  },
});

const entitlementDetailPage = PageBlueprint.make({
  name: 'entitlement-detail',
  params: {
    path: '/billing/entitlement/:entitlementID',
    routeRef: entitlementDetailsRouteRef,
    noHeader: true,
    loader: () =>
      import('./components').then(m => <m.UbsEntitlementDetailsPage />),
  },
});

export default createFrontendPlugin({
  pluginId: 'neo4j-ubs-billing',
  extensions: [
    billingAccountApi,
    searchPage,
    accountDetailPage,
    accountsListPage,
    entitlementDetailPage,
  ],
  routes: {
    root: rootRouteRef,
    accountDetails: accountDetailsRouteRef,
    accountsQuery: accountsQueryRouteRef,
    entitlementDetails: entitlementDetailsRouteRef,
  },
  info: {
    packageJson: () => import('../package.json'),
    manifest: () => import('../catalog-info.yaml'),
  },
});
